export default "__VITE_ASSET__CSc2yCcj__"